import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form"]

  connect() {
    
    // Listen for form submission
    this.formTarget.addEventListener("submit", this.handleSubmit.bind(this));
    
    // Listen for successful AJAX responses
    this.formTarget.addEventListener("ajax:success", this.handleAjaxSuccess.bind(this));
    
    // Listen for turbo frame/stream updates
    document.addEventListener("turbo:frame-load", this.handleTurboUpdate.bind(this));
    document.addEventListener("turbo:before-stream-render", this.handleTurboStream.bind(this));
  }

  disconnect() {
    this.formTarget.removeEventListener("submit", this.handleSubmit.bind(this));
    this.formTarget.removeEventListener("ajax:success", this.handleAjaxSuccess.bind(this));
    document.removeEventListener("turbo:frame-load", this.handleTurboUpdate.bind(this));
    document.removeEventListener("turbo:before-stream-render", this.handleTurboStream.bind(this));
  }

  handleSubmit(event) {
    // Store the selected theme value before submission
    const themeSelect = this.getThemeSelect();
    if (themeSelect) {
      this.pendingTheme = themeSelect.value;
      console.log("Pending theme:", this.pendingTheme);
    }
  }

  handleAjaxSuccess(event) {
    const [data, status, xhr] = event.detail;
    
    let theme = null;
    
    // Try to get theme from response
    if (xhr.getResponseHeader("Content-Type")?.includes("application/json")) {
      try {
        const response = typeof data === 'string' ? JSON.parse(data) : data;
        theme = response.theme;
      } catch (error) {
        console.error("Error parsing JSON response:", error);
      }
    }
    
    // Fallback to pending theme or current form value
    if (!theme) {
      theme = this.pendingTheme || this.getCurrentThemeValue();
    }
    
    if (theme) {
      this.updateTheme(theme);
    }
  }

  handleTurboUpdate(event) {
    this.checkAndUpdateTheme();
  }

  handleTurboStream(event) {
    // Delay to ensure DOM is updated
    setTimeout(() => {
      this.checkAndUpdateTheme();
    }, 100);
  }

  checkAndUpdateTheme() {
    const currentTheme = this.getCurrentThemeValue();
    if (currentTheme) {
      this.updateTheme(currentTheme);
    }
  }

  getCurrentThemeValue() {
    const themeSelect = this.getThemeSelect();
    return themeSelect ? themeSelect.value : null;
  }

  getThemeSelect() {
    // Try multiple selectors to find the theme select
    const selectors = [
      'select[name*="theme"]',
      'select[name="ai_options[theme]"]',
      '#ai_options_theme'
    ];
    
    for (const selector of selectors) {
      const element = this.element.querySelector(selector);
      if (element) {
        return element;
      }
    }
    
    console.warn("Theme select element not found");
    return null;
  }

  updateTheme(theme) {
    if (!theme) {
      console.warn("No theme provided for update");
      return;
    }

    
    const themeElements = [
      document.getElementById("currentTheme"),
      document.getElementById("currentSidebarTheme")
    ];
    
    let elementsFound = 0;
    themeElements.forEach(element => {
      if (element) {
        elementsFound++;
        const newClass = theme === "dark" ? "chat-theme-dark" : "chat-theme-light";
        element.className = newClass;
      }
    });
    
    if (elementsFound === 0) {
      console.warn("No theme elements found in DOM");
    }

    // Clear pending theme
    this.pendingTheme = null;
  }
}